export const countries = [
  { id: '1', name: 'Denmark', isoCode: 'dk' },
  { id: '2', name: 'England', isoCode: 'gb-eng' },
  { id: '3', name: 'Germany', isoCode: 'de' },
  { id: '4', name: 'Italy', isoCode: 'it' },
  { id: '5', name: 'France', isoCode: 'fr' },
  { id: '6', name: 'Sweden', isoCode: 'se' },
  { id: '7', name: 'Norway', isoCode: 'no' },
  { id: '8', name: 'Spain', isoCode: 'es' },
  { id: '9', name: 'Netherlands', isoCode: 'nl' },
  { id: '11', name: 'International', isoCode: '' },
  { id: '12', name: 'Portugal', isoCode: 'pt' },
  { id: '13', name: 'Turkiye', isoCode: 'tr' },
  { id: '14', name: 'Belgium', isoCode: 'be' },
  { id: '15', name: 'Scotland', isoCode: 'gb-sct' },
  { id: '16', name: 'USA', isoCode: 'us' },
  { id: '17', name: 'Slovenia', isoCode: 'si' },
  { id: '19', name: 'Czechia', isoCode: 'cz' },
  { id: '20', name: 'Serbia', isoCode: 'rs' },
  { id: '21', name: 'Romania', isoCode: 'ro' },
  { id: '22', name: 'Russia', isoCode: 'ru' },
  { id: '23', name: 'Canada', isoCode: 'ca' },
  { id: '24', name: 'Finland', isoCode: 'fi' },
  { id: '25', name: 'Japan', isoCode: 'jp' },
  { id: '26', name: 'Hungary', isoCode: 'hu' },
  { id: '28', name: 'South Africa', isoCode: 'za' },
  { id: '29', name: 'Tunisia', isoCode: 'tn' },
  { id: '30', name: 'Nigeria', isoCode: 'ng' },
  { id: '31', name: 'Egypt', isoCode: 'eg' },
  { id: '32', name: 'Cameroon', isoCode: 'cm' },
  { id: '33', name: 'Greece', isoCode: 'gr' },
  { id: '34', name: 'Austria', isoCode: 'at' },
  { id: '35', name: 'UAE', isoCode: 'ae' },
  { id: '37', name: 'Switzerland', isoCode: 'ch' },
  { id: '38', name: 'Israel', isoCode: 'il' },
  { id: '39', name: 'Australia', isoCode: 'au' },
  { id: '41', name: 'Luxembourg', isoCode: 'lu' },
  { id: '42', name: 'Northern Ireland', isoCode: 'gb-nir' },
  { id: '44', name: 'Croatia', isoCode: 'hr' },
  { id: '45', name: 'Ireland', isoCode: 'ie' },
  { id: '47', name: 'Poland', isoCode: 'pl' },
  { id: '48', name: 'Argentina', isoCode: 'ar' },
  { id: '50', name: 'Thailand', isoCode: 'th' },
  { id: '51', name: 'Brazil', isoCode: 'br' },
  { id: '52', name: 'Morocco', isoCode: 'ma' },
  { id: '53', name: 'Ukraine', isoCode: 'ua' },
  { id: '54', name: 'Malta', isoCode: 'mt' },
  { id: '55', name: 'Georgia', isoCode: 'ge' },
  { id: '56', name: 'Bulgaria', isoCode: 'bg' },
  { id: '57', name: 'Belarus', isoCode: 'by' },
  { id: '58', name: 'Wales', isoCode: 'gb-wls' },
  { id: '59', name: 'Cyprus', isoCode: 'cy' },
  { id: '60', name: 'Estonia', isoCode: 'ee' },
  { id: '61', name: 'Latvia', isoCode: 'lv' },
  { id: '62', name: 'Slovakia', isoCode: 'sk' },
  { id: '63', name: 'Saudi Arabia', isoCode: 'sa' },
  { id: '64', name: 'Azerbaijan', isoCode: 'az' },
  { id: '65', name: 'Moldova', isoCode: 'md' },
  { id: '66', name: 'Lithuania', isoCode: 'lt' },
  { id: '67', name: 'Faroe Islands', isoCode: 'fo' },
  { id: '68', name: 'North Macedonia', isoCode: 'mk' },
  { id: '69', name: 'Iceland', isoCode: 'is' },
  { id: '70', name: 'Bosnia and Herzegovina', isoCode: 'ba' },
  { id: '71', name: 'Albania', isoCode: 'al' },
  { id: '72', name: 'Armenia', isoCode: 'am' },
  { id: '73', name: 'San Marino', isoCode: 'sm' },
  { id: '74', name: 'Liechtenstein', isoCode: 'li' },
  { id: '76', name: 'Andorra', isoCode: 'ad' },
  { id: '77', name: 'Chile', isoCode: 'cl' },
  { id: '78', name: 'Colombia', isoCode: 'co' },
  { id: '79', name: 'Uruguay', isoCode: 'uy' },
  { id: '80', name: 'Ecuador', isoCode: 'ec' },
  { id: '81', name: 'Bolivia', isoCode: 'bo' },
  { id: '82', name: 'Paraguay', isoCode: 'py' },
  { id: '83', name: 'Peru', isoCode: 'pe' },
  { id: '84', name: 'Venezuela', isoCode: 've' },
  { id: '85', name: 'Algeria', isoCode: 'dz' },
  { id: '86', name: 'Greenland', isoCode: 'gl' },
  { id: '87', name: 'Kuwait', isoCode: 'kw' },
  { id: '88', name: 'South Korea', isoCode: 'kr' },
  { id: '89', name: 'Malaysia', isoCode: 'my' },
  { id: '90', name: 'Singapore', isoCode: 'sg' },
  { id: '91', name: 'Qatar', isoCode: 'qa' },
  { id: '92', name: 'Zimbabwe', isoCode: 'zw' },
  { id: '93', name: 'New Zealand', isoCode: 'nz' },
  { id: '94', name: 'Fiji', isoCode: 'fj' },
  { id: '95', name: 'Taiwan', isoCode: 'tw' },
  { id: '96', name: 'Myanmar', isoCode: 'mm' },
  { id: '98', name: 'Libya', isoCode: 'ly' },
  { id: '99', name: 'Togo', isoCode: 'tg' },
  { id: '100', name: 'Zambia', isoCode: 'zm' },
  { id: '101', name: 'Sudan', isoCode: 'sd' },
  { id: '102', name: 'Ghana', isoCode: 'gh' },
  { id: '103', name: 'Liberia', isoCode: 'lr' },
  { id: '104', name: 'Sierra Leone', isoCode: 'sl' },
  { id: '105', name: 'Namibia', isoCode: 'na' },
  { id: '106', name: 'Senegal', isoCode: 'sn' },
  { id: '107', name: 'Congo', isoCode: 'cg' },
  { id: '108', name: 'DR Congo', isoCode: 'cd' },
  { id: '109', name: 'Malawi', isoCode: 'mw' },
  { id: '110', name: 'Burkina Faso', isoCode: 'bf' },
  { id: '111', name: 'Ivory Coast', isoCode: 'ci' },
  { id: '112', name: 'Jamaica', isoCode: 'jm' },
  { id: '113', name: 'Trinidad and Tobago', isoCode: 'tt' },
  { id: '114', name: 'Mexico', isoCode: 'mx' },
  { id: '115', name: 'Nicaragua', isoCode: 'ni' },
  { id: '116', name: 'El Salvador', isoCode: 'sv' },
  { id: '117', name: 'Costa Rica', isoCode: 'cr' },
  { id: '118', name: 'Honduras', isoCode: 'hn' },
  { id: '119', name: 'Angola', isoCode: 'ao' },
  { id: '120', name: 'Madagascar', isoCode: 'mg' },
  { id: '121', name: 'North Korea', isoCode: 'kp' },
  { id: '122', name: 'Iran', isoCode: 'ir' },
  { id: '123', name: 'Iraq', isoCode: 'iq' },
  { id: '125', name: 'China', isoCode: 'cn' },
  { id: '126', name: 'Mali', isoCode: 'ml' },
  { id: '127', name: 'Jordan', isoCode: 'jo' },
  { id: '128', name: 'Hong Kong', isoCode: 'hk' },
  { id: '129', name: 'Kazakhstan', isoCode: 'kz' },
  { id: '130', name: 'Uzbekistan', isoCode: 'uz' },
  { id: '131', name: 'Benin', isoCode: 'bj' },
  { id: '133', name: 'India', isoCode: 'in' },
  { id: '134', name: 'Oman', isoCode: 'om' },
  { id: '135', name: 'Laos', isoCode: 'la' },
  { id: '136', name: 'Guatemala', isoCode: 'gt' },
  { id: '137', name: 'Cuba', isoCode: 'cu' },
  { id: '138', name: 'Martinique', isoCode: 'mq' },
  { id: '139', name: 'Haiti', isoCode: 'ht' },
  { id: '140', name: 'Bahamas', isoCode: 'bs' },
  { id: '141', name: 'Indonesia', isoCode: 'id' },
  { id: '142', name: 'Puerto Rico', isoCode: 'pr' },
  { id: '143', name: 'Panama', isoCode: 'pa' },
  { id: '144', name: 'Bahrain', isoCode: 'bh' },
  { id: '145', name: 'Rwanda', isoCode: 'rw' },
  { id: '146', name: 'Guinea', isoCode: 'gn' },
  { id: '147', name: 'Kenya', isoCode: 'ke' },
  { id: '148', name: 'Yemen', isoCode: 'ye' },
  { id: '149', name: 'Barbados', isoCode: 'bb' },
  { id: '150', name: 'Kyrgyzstan', isoCode: 'kg' },
  { id: '151', name: 'Botswana', isoCode: 'bw' },
  { id: '152', name: 'Gabon', isoCode: 'ga' },
  { id: '153', name: 'Cape Verde', isoCode: 'cv' },
  { id: '154', name: 'Uganda', isoCode: 'ug' },
  { id: '155', name: 'Vietnam', isoCode: 'vn' },
  { id: '156', name: 'Sri Lanka', isoCode: 'lk' },
  { id: '157', name: 'Palestine', isoCode: 'ps' },
  { id: '158', name: 'Syria', isoCode: 'sy' },
  { id: '159', name: 'Tajikistan', isoCode: 'tj' },
  { id: '160', name: 'Lebanon', isoCode: 'lb' },
  { id: '161', name: 'Maldives', isoCode: 'mv' },
  { id: '162', name: 'Turkmenistan', isoCode: 'tm' },
  { id: '163', name: 'Pakistan', isoCode: 'pk' },
  { id: '164', name: 'Dominican Republic', isoCode: 'do' },
  { id: '165', name: 'St. Kitts and Nevis', isoCode: 'kn' },
  { id: '166', name: 'Saint Vincent and The Grenadines', isoCode: 'vc' },
  { id: '167', name: 'Vanuatu', isoCode: 'vu' },
  { id: '168', name: 'French Polynesia', isoCode: 'pf' },
  { id: '169', name: 'Solomon Islands', isoCode: 'sb' },
  { id: '170', name: 'Great Britain', isoCode: 'gb' },
  { id: '171', name: 'Tonga', isoCode: 'to' },
  { id: '172', name: 'Philippines', isoCode: 'ph' },
  { id: '173', name: 'Mongolia', isoCode: 'mn' },
  { id: '174', name: 'Afghanistan', isoCode: 'af' },
  { id: '175', name: 'Lesotho', isoCode: 'ls' },
  { id: '176', name: 'Nepal', isoCode: 'np' },
  { id: '177', name: 'Ethiopia', isoCode: 'et' },
  { id: '178', name: 'Mauritius', isoCode: 'mu' },
  { id: '179', name: 'Seychelles', isoCode: 'sc' },
  { id: '180', name: 'Brunei', isoCode: 'bn' },
  { id: '181', name: 'U.S. Virgin Islands', isoCode: 'vi' },
  { id: '182', name: 'Micronesia', isoCode: 'fm' },
  { id: '183', name: 'Bermuda', isoCode: 'bm' },
  { id: '184', name: 'Nauru', isoCode: 'nr' },
  { id: '185', name: 'Central African Rep.', isoCode: 'cf' },
  { id: '186', name: 'Guam', isoCode: 'gu' },
  { id: '187', name: 'Netherlands Antilles', isoCode: '' },
  { id: '188', name: 'Bangladesh', isoCode: 'bd' },
  { id: '189', name: 'Bhutan', isoCode: 'bt' },
  { id: '190', name: 'Monaco', isoCode: 'mc' },
  { id: '192', name: 'Antigua and Barbuda', isoCode: 'ag' },
  { id: '193', name: 'American Samoa', isoCode: 'as' },
  { id: '194', name: 'Belize', isoCode: 'bz' },
  { id: '195', name: 'Aruba', isoCode: 'aw' },
  { id: '196', name: 'Burundi', isoCode: 'bi' },
  { id: '197', name: 'Cayman Islands', isoCode: 'ky' },
  { id: '198', name: 'Djibouti', isoCode: 'dj' },
  { id: '199', name: 'Dominica', isoCode: 'dm' },
  { id: '200', name: 'Equatorial Guinea', isoCode: 'gq' },
  { id: '201', name: 'Eritrea', isoCode: 'er' },
  { id: '202', name: 'Cook Islands', isoCode: 'ck' },
  { id: '203', name: 'Cambodia', isoCode: 'kh' },
  { id: '204', name: 'French Guiana', isoCode: 'gf' },
  { id: '205', name: 'Gambia', isoCode: 'gm' },
  { id: '206', name: 'Saint Lucia', isoCode: 'lc' },
  { id: '207', name: 'Niger', isoCode: 'ne' },
  { id: '208', name: 'Papua New Guinea', isoCode: 'pg' },
  { id: '209', name: 'Chad', isoCode: 'td' },
  { id: '210', name: 'Eswatini', isoCode: 'sz' },
  { id: '211', name: 'Comoros', isoCode: 'km' },
  { id: '212', name: 'Kiribati', isoCode: 'ki' },
  { id: '213', name: 'Grenada', isoCode: 'gd' },
  { id: '214', name: 'British Virgin Islands', isoCode: 'vg' },
  { id: '215', name: 'Mozambique', isoCode: 'mz' },
  { id: '216', name: 'Guyana', isoCode: 'gy' },
  { id: '217', name: 'Mauritania', isoCode: 'mr' },
  { id: '218', name: 'Tanzania', isoCode: 'tz' },
  { id: '219', name: 'Somalia', isoCode: 'so' },
  { id: '220', name: 'Suriname', isoCode: 'sr' },
  { id: '221', name: 'Sao Tome and Principe', isoCode: 'st' },
  { id: '222', name: 'Former East Timor', isoCode: 'tl' },
  { id: '223', name: 'Palau', isoCode: 'pw' },
  { id: '224', name: 'Samoa', isoCode: 'ws' },
  { id: '225', name: 'Europe', isoCode: '' },
  { id: '226', name: 'GB/Ireland', isoCode: 'gb' },
  { id: '227', name: 'Asia', isoCode: '' },
  { id: '228', name: 'Macao', isoCode: 'mo' },
  { id: '229', name: 'Guadeloupe', isoCode: 'gp' },
  { id: '230', name: 'Montenegro', isoCode: 'me' },
  { id: '465', name: 'Unknown', isoCode: '' },
  { id: '652', name: 'Undefined', isoCode: '' },
  { id: '653', name: 'East Timor', isoCode: 'tl' },
  { id: '654', name: 'New Caledonia', isoCode: 'nc' },
  { id: '655', name: 'Gibraltar', isoCode: 'gi' },
  { id: '656', name: 'Guinea-Bissau', isoCode: 'gw' },
  { id: '657', name: 'Marshall Islands', isoCode: 'mh' },
  { id: '658', name: 'Tuvalu', isoCode: 'tv' },
  { id: '659', name: 'Jersey', isoCode: 'je' },
  { id: '660', name: 'Christmas Island', isoCode: 'cx' },
  { id: '661', name: 'Anguilla', isoCode: 'ai' },
  { id: '662', name: 'Montserrat', isoCode: 'ms' },
  { id: '663', name: 'Turks and Caicos Islands', isoCode: 'tc' },
  { id: '664', name: 'Curacao', isoCode: 'cw' },
  { id: '665', name: 'Zanzibar', isoCode: 'tz' },
  { id: '666', name: 'South Sudan', isoCode: 'ss' },
  { id: '667', name: 'Northern Mariana Islands', isoCode: 'mp' },
  { id: '668', name: 'Kosovo', isoCode: 'xk' },
  { id: '669', name: 'Yugoslavia', isoCode: '' },
  { id: '670', name: 'West Germany', isoCode: 'de' },
  { id: '671', name: 'East Germany', isoCode: '' },
  { id: '672', name: 'Soviet Union', isoCode: '' },
  { id: '673', name: 'Czechoslovakia', isoCode: '' },
  { id: '674', name: 'Dutch East Indies', isoCode: 'id' },
  { id: '675', name: 'Zaire', isoCode: 'cd' },
  { id: '676', name: 'Crimea', isoCode: 'ua' },
  { id: '677', name: 'Niue', isoCode: 'nu' },
  { id: '678', name: 'Sint Maarten', isoCode: 'sx' },
  { id: '679', name: 'Isle of Man', isoCode: 'im' },
  { id: '680', name: 'Guernsey', isoCode: 'gg' },
  { id: '681', name: 'Bonaire', isoCode: 'bq' },
  { id: '682', name: 'Saint Martin', isoCode: 'mf' },
  { id: '684', name: 'Reunion', isoCode: 're' },
  { id: '685', name: 'Serbia and Montenegro', isoCode: 'rs' },
  { id: '686', name: 'Bohemia', isoCode: 'cz' },
  { id: '687', name: 'Wallis and Futuna', isoCode: 'wf' },
  { id: '688', name: 'Commonwealth of Independent States', isoCode: 'ru' },
];
